<template>
  <div>
    <div class="modal-overlay" @click.self="closePaidHistoryModal">
      <div class="modal-content">
        <div id="scroller">
        <div v-if="payHistory.length === 0" class="empty-state">
          <p>No payment history found.</p>
        </div>
        <div class="pay-history flex items-center gap-4 py-2 px-2" v-for="(payH, index) in payHistory" :key="index">
          <p>{{payH.eventType}} <span>{{ createdAt(payH.date) }}</span></p>
          <h3>{{payH.amount}}</h3>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      payHistory: [
            // {type: "Paid |", date: "20 Feb, 2025", amount:"N750,000.00"},
            // {type: "Cash Out |", date: "14 Feb, 2025", amount:"N1,500,000.00"}
          ],        
    };
  },

   mounted() {
      this.getPaidHistory()
    },

  methods: {
    closePaidHistoryModal() {
      this.$emit("close-payhistory-modal")
    },
    createdAt(val) {
      return moment(val).format('DD-MM-YYYY')
    },
     async getPaidHistory() {
      let response = await this.$_getCashoutHistory()
      this.payHistory = response?.data?.data?.history

    },
  },
}
</script>

<style scoped>
#scroller {
  max-height: 500px;
  overflow-y: auto;
}
.empty-state {
  text-align: center;
  padding: 20px 0;
  color: #7A90A7;
  font-size: 14px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-items: center; */
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
}

.pay-history{
  /* border: 1px solid red; */
}
.pay-history>p{
  font-size: 12px;
  font-weight: 600;
  color: #7A90A7;
  /* border: 1px solid blue; */
  flex-basis: 60%;
}
.pay-history>h3{
  font-size: 14px;
  font-weight: 600;
  color: #383F51;
  /* border: 1px solid green; */
  flex-basis: 40%;
}


</style>